import { useState, useEffect } from 'react';
import Cookies from 'js-cookie';

import { HeroModel, MediaModel } from '@vp/digital-common-data-model-lib';

type QueryResult = {
  called: boolean;
  loading: boolean;
  error: Error | undefined;
  data: { businessCategory: string | undefined; isMapped: boolean };
};

export const useBusinessCategory = (hero: HeroModel) => {
  const [result, setResult] = useState<QueryResult>({
    called: false,
    loading: false,
    error: undefined,
    data: {
      businessCategory: undefined,
      isMapped: undefined,
    },
  });

  useEffect(() => {
    setResult({
      called: true,
      loading: true,
      error: undefined,
      data: {
        businessCategory: undefined,
        isMapped: undefined,
      },
    });

    function isBusinessCategoryMapped(
      businessCategory: string | undefined
    ): boolean {
      if (!businessCategory) return false;
      return !!hero?.mediaList?.find(
        (item: MediaModel) => item?.key === businessCategory
      );
    }

    try {
      const userContextData = JSON.parse(Cookies.get('userContext') || '{}');
      const industryL1Id =
        userContextData?.userProfile?.v1?.industry_l1_id || '';

      setResult({
        called: true,
        loading: false,
        error: undefined,
        data: {
          businessCategory: industryL1Id,
          isMapped: isBusinessCategoryMapped(industryL1Id),
        },
      });
    } catch (e) {
      setResult({
        called: true,
        loading: false,
        error: e as Error,
        data: {
          businessCategory: undefined,
          isMapped: undefined,
        },
      });
    }
  }, []);

  return result;
};
